var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftNav" },
    [
      _c("div", { attrs: { id: "head_img" } }, [
        _c("div", { staticClass: "rightgo" }, [
          _vm.isJgj === "1"
            ? _c("div", { staticClass: "directSend" }, [_vm._v("紧固件")])
            : _c("div", [
                _vm.shopType === "1"
                  ? _c("div", { staticClass: "directSend" }, [_vm._v("直发")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.shopType === "0"
                  ? _c("div", { staticClass: "inDirectSend" }, [_vm._v("平台")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.shopType === "2"
                  ? _c("div", { staticClass: "directSend" }, [_vm._v("工厂")])
                  : _vm._e()
              ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "login_name" }, [_vm._v(_vm._s(_vm.user))]),
      _vm._v(" "),
      _c("p", { staticClass: "shop-status" }, [
        _vm._v("(" + _vm._s(_vm.currenttype) + ")")
      ]),
      _vm._v(" "),
      _vm.token ? _c("WebSocket") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f07b5c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f07b5c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Avatar.vue
// module id = null
// module chunks = 